export default __webpack_public_path__ + "static/media/FlowDesk-login.d64f60d1.png";